module.exports = __webpack_public_path__ + "static/media/21ECLAC50.ab01c9ac.jpg";